export const getAllRepaymentAction = (state = [], action) => {
  switch (action.type) {
    case "GET_ALL_REPAYMENT_DETAILS":
      return action.data;

    default:
      return state;
  }
};
